import React from "react";
import { QueryClient, QueryClientProvider } from "react-query";

const withQueryClientProvider = <T extends {}>(
	WrappedComponent: React.ComponentType<T>
) => {
	const Component = (props: T) => (
		<QueryClientProvider client={new QueryClient()}>
			<WrappedComponent {...props} />
		</QueryClientProvider>
	);
	Component.displayName = `withQueryClientProvider`;
	return Component;
};

export default withQueryClientProvider;
